import { atom } from "jotai";
import { AccountType } from "../../../model/AccountType";

export const accountTypesAtom = atom<AccountType[] | undefined>(undefined);
